import util from '@/common/util';

/**
 * 组件已放在sign-log下，仅可使用isShow判断是否能显示广告注册弹窗
 */
export default {
    isShow(globalData) {
        /*responsive form弹窗只有在landing-page的广告页才有，
        进入该页会设置cookie enableDynamicRegister=1，
        如果从该页出来之后仍然可以保持登录注册弹窗是responsive 
        form只有清除cookie或者进入了非广告的landing-page后才可以清除responsive form弹窗*/
        return (
            globalData.registration?.autopopup?.isDynamicRegister ||
            util.getCookie('enableDynamicRegister') == '1'
        );
    }
};
